import React, { useState } from 'react'
import { useParams } from 'react-router'

import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import DistrictFormComp from '../../components/version-4/MasterForms/DistrictFormComp'
import StateFormComp from '../../components/version-4/MasterForms/StateFormComp'
import { useDistrict } from '../../hooks/CompanyConfiguration/useDistrict'
import { ROUTES } from '../../shared/constants'
function EditDistrict() {
  const [data, setdata] = useState({
    name: '',
    region: '',
    zone: '',
    state1: '',
    districtCode: '',
    active: '',
  })
  const { district, getDistrict, updateDistrict } = useDistrict()

  const params = useParams()

  React.useEffect(() => {
    getDistrict({ districtId: params.districtId })
  }, [params.districtId])

  React.useEffect(() => {
    if (district) {
      setdata({
        name: district.name,
        region: district.region._id,
        zone: district.zone._id,
        state1: district.state._id,
        districtCode: district.districtCode,
        active: district.active,
      })
    }
  }, [district])

  const handleDistrict = () => {
    updateDistrict({
      name: data.name,
      region: data.region,
      zone: data.zone,
      state: data.state1,
      districtCode: data.districtCode,
      active: data.active,
      districtId: params.districtId,
    })
  }
  return (
    <Layout heading="District" heading2="Edit" url1={ROUTES.DISTRICT} none>
      {district ? (
        <HeaderTabLayout heading="Edit District" state={data} setState={setdata} content={<DistrictFormComp state={data} setState={setdata} edit={district ? true : false} />} addContent={handleDistrict} redirect={ROUTES.DISTRICT} />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}

export default EditDistrict
